/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.diaposImportees.ts
 *
 * Diapositives IMPORTÉES de la présentation qui défile (2026-10-09, Mika :
 * diffuser dans la boucle des images 16:9 exportées d'un PowerPoint, qu'il
 * choisit et ordonne). Fusionné dans fr.ts.
 * Aucun tiret cadratin, apostrophe typographique.
 *
 * Mikael - chef de projet - 2026-10-09
 */
export const messagesDiaposImporteesFr: Record<string, string> = {
  'presentation.controles.diapos': 'Diapositives importées',
  'presentation.image.alt': 'Diapositive importée {n}',
  'presentation.diapos.titre': 'Diapositives importées',
  'presentation.diapos.intro':
    'Des images 16:9 (par exemple les diapositives d’un PowerPoint exportées en PNG ou JPEG, 1920 x 1080) diffusées en tête de la boucle, dans cet ordre. Rien n’est enregistré sans le bouton « Enregistrer ».',
  'presentation.diapos.fermer': 'Fermer',
  'presentation.diapos.compte': '{n, plural, =0 {aucune diapositive} one {# diapositive} other {# diapositives}} sur {max}',
  'presentation.diapos.vide': 'Aucune diapositive importée : la présentation montre ses diapositives automatiques.',
  'presentation.diapos.ajouterLabel': 'Nouvelle diapositive (image PNG, JPEG ou WebP)',
  'presentation.diapos.televerser': 'Téléverser une image',
  'presentation.diapos.televersee': 'Image téléversée : cliquez sur « Ajouter à la liste ».',
  'presentation.diapos.apercu': 'Aperçu de l’image téléversée',
  'presentation.diapos.ajouter': 'Ajouter à la liste',
  'presentation.diapos.formatRefuse':
    'Image refusée : déposez un fichier PNG, JPEG ou WebP avec le bouton « Téléverser une image ».',
  'presentation.diapos.plein': 'Trente diapositives au plus.',
  'presentation.diapos.vignette': 'Diapositive {n}',
  'presentation.diapos.titreLabel': 'Titre de la diapositive {n} (facultatif)',
  'presentation.diapos.titrePlaceholder': 'Titre facultatif, lu par les lecteurs d’écran',
  'presentation.diapos.monter': 'Monter la diapositive {n}',
  'presentation.diapos.descendre': 'Descendre la diapositive {n}',
  'presentation.diapos.retirer': 'Retirer la diapositive {n}',
  'presentation.diapos.seulement': 'Ne diffuser que ces diapositives',
  'presentation.diapos.seulementAide':
    'Si la liste est vide, ou si aucune image ne s’affiche, les diapositives automatiques reviennent.',
  'presentation.diapos.enregistrer': 'Enregistrer',
  'presentation.diapos.enregistre': 'Diapositives enregistrées : la présentation les diffuse dès maintenant.',
  'presentation.diapos.erreur': 'Enregistrement impossible : {detail}',
  'presentation.diapos.erreurInconnue': 'réessayez dans un instant.',
  'presentation.diapos.nonEnregistre': 'Modifications non enregistrées.',
  'presentation.diapos.chargement': 'Chargement des diapositives importées…',
  'presentation.diapos.lectureImpossible': 'Lecture impossible des diapositives importées : réessayez dans un instant.',
};
